import { USER_UPGRADE_CLEAR } from '@/constants/constants';
const HYDRATE = "__NEXT_REDUX_WRAPPER_HYDRATE__";

export const types = {
  GET_CATALOGUE_PRODUCT_OFFERING_SUCCESS: 'GET_PRODUCT_OFFERING_SUCCESS',
  GET_CATALOGUE_PRODUCT_OFFERING_BEGINS: 'GET_PRODUCT_OFFERING_BEGINS',
  GET_CATALOGUE_PRODUCT_OFFERING_FAILURE: 'GET_PRODUCT_OFFERING_FAILURE',
  GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_SUCCESS:
    'GET_PRODUCT_OFFERING_ATTACHMENTS_SUCCESS',
  GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_BEGINS:
    'GET_PRODUCT_OFFERING_ATTACHMENTS_BEGINS',
  GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_FAILURE:
    'GET_PRODUCT_OFFERING_ATTACHMENTS_FAILURE',
  GET_IS_R2_AVAILABLE_TO_PURCHASE_BEGIN:
    'GET_IS_R2_AVAILABLE_TO_PURCHASE_BEGIN',
  GET_IS_R2_AVAILABLE_TO_PURCHASE_SUCCESS:
    'GET_IS_R2_AVAILABLE_TO_PURCHASE_SUCCESS',
  GET_IS_R2_AVAILABLE_TO_PURCHASE_FAILURE:
    'GET_IS_R2_AVAILABLE_TO_PURCHASE_FAILURE',
};
export const actions = {
  getCatalogueProductOffering: (idPO) => ({
    type: types.GET_CATALOGUE_PRODUCT_OFFERING_BEGINS,
    idPO,
  }),
  successGetCatalogueProductOffering: (data) => ({
    type: types.GET_CATALOGUE_PRODUCT_OFFERING_SUCCESS,
    payload: { data },
  }),
  failureGetCatalogueProductOffering: () => ({
    type: types.GET_CATALOGUE_PRODUCT_OFFERING_FAILURE,
  }),
  getCatalogueProductOfferingAttachments: (idPO) => ({
    type: types.GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_BEGINS,
    idPO,
  }),
  successGetCatalogueProductOfferingAttachments: (data) => ({
    type: types.GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_SUCCESS,
    payload: { data },
  }),
  failureGetCatalogueProductOfferingAttachments: () => ({
    type: types.GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_FAILURE,
  }),
  getIsR2RAvailableToPurchase: (params) => ({
    type: types.GET_IS_R2_AVAILABLE_TO_PURCHASE_BEGIN,
    params,
  }),
  successIsR2RAvailableToPurchase: (data) => ({
    type: types.GET_IS_R2_AVAILABLE_TO_PURCHASE_SUCCESS,
    payload: data,
  }),
  failureIsR2RAvailableToPurchase: (error) => ({
    type: types.GET_IS_R2_AVAILABLE_TO_PURCHASE_FAILURE,
    payload: error,
  }),
};
export const initialState = {
  catalogueProductOffering: {},
  catalogueProductOfferingError: false,
  catalogueProductOfferingFetching: false,
  catalogueProductOfferingAttachments: {},
  catalogueProductOfferingAttachmentsError: false,
  catalogueProductOfferingAttachmentsFetching: false,

  isR2RAvailableToPurchase: null,
  isR2RAvailableToPurchaseFetching: false,
  isR2RAvailableToPurchaseError: false,
};
function reducer(state = { ...initialState }, { type, payload }) {
  switch (type) {
    case HYDRATE: {
      const { catalogue } = payload;
      return {
        ...state,
        ...catalogue,
      };
    }
    case USER_UPGRADE_CLEAR:
      return initialState;
    case types.GET_CATALOGUE_PRODUCT_OFFERING_BEGINS:
      return {
        ...state,
        catalogueProductOfferingError: false,
        catalogueProductOfferingFetching: true,
      };
    case types.GET_CATALOGUE_PRODUCT_OFFERING_SUCCESS: {
      let newCatalogueProductOffering = state.catalogueProductOffering;
      if (payload.data) {
        newCatalogueProductOffering = {
          ...state.catalogueProductOffering,
          [payload.data.id]: payload.data,
        };
      }
      return {
        ...state,
        catalogueProductOffering: newCatalogueProductOffering,
        catalogueProductOfferingError: false,
        catalogueProductOfferingFetching: false,
      };
    }
    case types.GET_CATALOGUE_PRODUCT_OFFERING_FAILURE:
      return {
        ...state,
        catalogueProductOfferingFetching: false,
        catalogueProductOfferingError: true,
      };
    case types.GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_BEGINS:
      return {
        ...state,
        catalogueProductOfferingAttachmentsFetching: true,
        catalogueProductOfferingAttachmentsError: false,
      };
    case types.GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_SUCCESS: {
      let newCatalogueProductOfferingAttachments =
        state.catalogueProductOfferingAttachments;

      if (payload.data) {
        newCatalogueProductOfferingAttachments = {
          ...state.catalogueProductOfferingAttachments,
          [payload.data.productOffering]: payload.data,
        };
      }
      return {
        ...state,
        catalogueProductOfferingAttachments:
          newCatalogueProductOfferingAttachments,
        catalogueProductOfferingAttachmentsError: false,
        catalogueProductOfferingAttachmentsFetching: false,
      };
    }
    case types.GET_CATALOGUE_PRODUCT_OFFERING_ATTACHMENTS_FAILURE:
      return {
        ...state,
        catalogueProductOfferingAttachmentsFetching: false,
        catalogueProductOfferingAttachmentsError: true,
      };
    case types.GET_IS_R2_AVAILABLE_TO_PURCHASE_BEGIN: {
      return {
        ...state,
        isR2RAvailableToPurchaseFetching: true,
        isR2RAvailableToPurchaseError: false,
      };
    }
    case types.GET_IS_R2_AVAILABLE_TO_PURCHASE_SUCCESS: {
      return {
        ...state,
        isR2RAvailableToPurchase: payload,
        isR2RAvailableToPurchaseFetching: false,
        isR2RAvailableToPurchaseError: false,
      };
    }
    case types.GET_IS_R2_AVAILABLE_TO_PURCHASE_FAILURE: {
      return {
        ...state,
        isR2RAvailableToPurchase: null,
        isR2RAvailableToPurchaseFetching: false,
        isR2RAvailableToPurchaseError: true,
      };
    }
    default:
      return state;
  }
}

export default reducer;
